import { QueryStatus, useQuery } from '@tanstack/react-query';

import fetchViews from './fetchViews';
import { View } from '../CommonTypes';
import useSite from './useSite';

export default function useViews() {
  const [site] = useSite();

  const results = useQuery({
    queryKey: ['company', site.company, 'siteid', site.siteid, 'views'],
    queryFn: () => fetchViews(site.company, site.siteid),
  });

  return [results?.data ?? [], results.status] as [View[], QueryStatus];
}
